export default __webpack_public_path__ + "bd6693240cf749241d53b3499649883e.riv";